import { CalendarClock, CheckCircle2 } from "lucide-react";

/**
 * Lead Assignment row tags: a live policy (unassign keeps those with their agent) and the
 * next upcoming appointment, so an owner sees what the agent has going before pulling a lead.
 */
export function LeadRowTags({
  hasPolicy,
  nextAppointmentAt,
  nextAppointmentWith,
}: {
  hasPolicy?: boolean;
  nextAppointmentAt?: string | null;
  nextAppointmentWith?: string | null;
}) {
  const appt = nextAppointmentAt ? new Date(nextAppointmentAt) : null;
  const hasAppt = !!appt && !Number.isNaN(appt.getTime());
  return (
    <>
      {hasPolicy && (
        <span
          className="inline-flex items-center gap-0.5 px-1.5 py-0.5 text-[10px] font-medium rounded bg-emerald-50 text-emerald-700"
          title="Has a policy. Unassign keeps it with its agent unless you include sold/closed leads."
        >
          <CheckCircle2 className="h-2.5 w-2.5" />
          Policy
        </span>
      )}
      {hasAppt && (
        <span
          className="inline-flex items-center gap-0.5 px-1.5 py-0.5 text-[10px] font-medium rounded bg-cyan-50 text-cyan-700"
          title={`Appointment ${appt.toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })}${nextAppointmentWith ? ` with ${nextAppointmentWith}` : ""}`}
        >
          <CalendarClock className="h-2.5 w-2.5" />
          Appt {appt.toLocaleDateString("en-US", { month: "short", day: "numeric" })}
        </span>
      )}
    </>
  );
}
